import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';
import { Textarea } from './../../models/editors/textarea.model';
import { Switch } from './../../models/editors/switch.model';

import { Slide } from './../../models/slides/slides.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { Contained } from './../../models/editors/contained.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';

@Component({
  selector: 'swb-slide-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class SlideDetailComponent extends FormDetailBase<Slide> implements OnInit {

  public entity = new Slide({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'claim',
        label: 'Hlavní nadpis',
        isMultilang: true
      }),
      new Textbox({
        key: 'subclaim',
        label: 'Podnadpis',
        isMultilang: true
      }),
      new Textarea({
        key: 'text',
        label: 'Text',
        isMultilang: true
      }),
      new Switch({
        key: 'has_button',
        label: 'Obsahuje tlačítko',
        isMultilang: true,
        labelFalse: 'Neobsahuje tlačítko'
      }),
      new Textbox({
        key: 'url_label',
        label: 'Text odkazu',
        boundTo: 'has_button',
        isMultilang: true
      }),
      new Textbox({
        key: 'url',
        label: 'Url odkazu',
        boundTo: 'has_button',
        isMultilang: true
      }),
      new Contained({
        key: 'file_id',
        label: 'Obrázek',
        upload: true,
        entity: this.entity.file
      })
    ];
  }

  public url = 'slides';
  protected _redirect = 'homepage';

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getEntity();

  }

}
